function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-9 -9)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  stroke: "#000"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.087 19.42a.5.5 0 01-.707-.707l5.333-5.333a.5.5 0 01.707.707l-5.333 5.333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.687 13.554a.5.5 0 11-.707-.708l1.783-1.783a3.518 3.518 0 014.974 4.974l-1.783 1.783a.5.5 0 01-.708-.707l1.784-1.783a2.518 2.518 0 00-3.56-3.56l-1.783 1.784zm-2.841 1.426a.5.5 0 01.708.707L11.77 17.47a2.518 2.518 0 003.56 3.56l1.783-1.784a.5.5 0 11.707.708l-1.783 1.783a3.518 3.518 0 01-4.974-4.974l1.783-1.783z"
})));

function SvgUrl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkgLTkpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgc3Ryb2tlPSIjMDAwIi8+CiAgICAgICAgPGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTE0LjA4NyAxOS40MmEuNS41IDAgMCAxLS43MDctLjcwN2w1LjMzMy01LjMzM2EuNS41IDAgMCAxIC43MDcuNzA3bC01LjMzMyA1LjMzM3oiLz4KICAgICAgICAgICAgPHBhdGggZD0iTTE1LjY4NyAxMy41NTRhLjUuNSAwIDEgMS0uNzA3LS43MDhsMS43ODMtMS43ODNhMy41MTggMy41MTggMCAwIDEgNC45NzQgNC45NzRsLTEuNzgzIDEuNzgzYS41LjUgMCAwIDEtLjcwOC0uNzA3bDEuNzg0LTEuNzgzYTIuNTE4IDIuNTE4IDAgMCAwLTMuNTYtMy41NmwtMS43ODMgMS43ODR6TTEyLjg0NiAxNC45OGEuNS41IDAgMCAxIC43MDguNzA3TDExLjc3IDE3LjQ3YTIuNTE4IDIuNTE4IDAgMCAwIDMuNTYgMy41NmwxLjc4My0xLjc4NGEuNS41IDAgMSAxIC43MDcuNzA4bC0xLjc4MyAxLjc4M2EzLjUxOCAzLjUxOCAwIDAgMS00Ljk3NC00Ljk3NGwxLjc4My0xLjc4M3oiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgUrl as ReactComponent };